import React, { forwardRef, useImperativeHandle } from "react"

export const WebView = forwardRef(function WebView(_props, ref) {
  useImperativeHandle(ref, () => ({
    injectJavaScript: () => {},
    postMessage: () => {},
  }))
  return null
})

export default WebView
